/** Joins base URL and path without duplicate slashes (e.g. base ends with /, path starts with /). */
export const joinBaseUrlAndPath = (baseUrl: string, path: string): string => {
  if (/^https?:\/\//i.test(path)) {
    return normalizeHttpUrl(path);
  }
  const base = baseUrl.replace(/\/+$/, "");
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return normalizeHttpUrl(`${base}${normalizedPath}`);
};

/** Collapses accidental double slashes in http(s) URLs (keeps protocol:// intact). */
export const normalizeHttpUrl = (url: string): string => {
  const match = url.match(/^(https?:\/\/)(.*)$/i);
  if (!match) return url;
  return `${match[1]}${match[2].replace(/\/{2,}/g, "/")}`;
};
